__webpack_require__.p = "/openam/yui/";